import { useCallback, useLayoutEffect, useRef } from 'react';
/**
 * Выдвигает за текст первую иконку в многострочном режиме,
 * устанавливая CSS-переменную, которая используется для вычисления padding и margin.
 */
export function useLeadingIcon(_ref) {
  let {
    allowIconLeading,
    beforeIcon,
    inline
  } = _ref;
  const linkRef = useRef(null);
  const beforeIconRef = useRef(null);
  const resetIconLeading = useCallback(() => {
    if (typeof window !== 'undefined' && linkRef.current) {
      linkRef.current.style.setProperty('--leading-icon-indent', '0');
    }
  }, []);
  const setIconLeading = useCallback(() => {
    if (typeof window === 'undefined' || !linkRef.current || !beforeIconRef.current) {
      return;
    }
    const beforeIconRect = beforeIconRef.current.getBoundingClientRect();
    const iconGap = parseInt(window.getComputedStyle(linkRef.current).getPropertyValue('--icon-gap'), 10);
    linkRef.current.style.setProperty('--leading-icon-indent', "".concat(beforeIconRect.width + iconGap, "px"));
  }, []);
  useLayoutEffect(() => {
    if (allowIconLeading && beforeIcon && !inline && linkRef.current) {
      setIconLeading();
    } else {
      resetIconLeading();
    }
  }, [allowIconLeading, beforeIcon, inline, setIconLeading, resetIconLeading]);
  return {
    linkRef,
    beforeIconRef
  };
}